import Marquee from "react-fast-marquee";

const ITEMS = [
  "Hotel Bookings",
  "Airport Transfers",
  "Tours",
  "Group Travel & FIT",
  "Study Abroad",
  "Medical Tourism",
  "Corporate Travel",
  "Real Estate Support",
];

const Diamond = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true" className="mx-8 shrink-0 md:mx-12">
    <rect x="2.2" y="2.2" width="5.6" height="5.6" transform="rotate(45 5 5)" fill="#184167" />
  </svg>
);

export default function MarqueeStrip() {
  return (
    <section
      data-testid="marquee-strip"
      className="overflow-hidden border-y border-[#E2E8F0] bg-[#F0F4F8] py-8 md:py-10"
      aria-hidden="true"
    >
      <Marquee speed={32} gradient={false}>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="whitespace-nowrap font-display text-2xl font-light italic tracking-wide text-[#184167] md:text-4xl">
              {item}
            </span>
            <Diamond />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
